/**
 * 返修工单详情页
 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Descriptions, Divider, Tag, Button, Space, Spin, Modal, Form, Input, InputNumber, Select, message } from 'antd';
import { CheckOutlined, EditOutlined } from '@ant-design/icons';
import { returnApi } from '../../services/api';

const statusMap = { pending: '待处理', sent: '已寄出', processing: '处理中', completed: '已办结', cancelled: '已取消' };
const statusColors = { pending: 'orange', sent: 'blue', processing: 'processing', completed: 'success', cancelled: 'error' };

function ReturnDetail() {
  const { id } = useParams();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusModal, setStatusModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [form] = Form.useForm();

  const loadDetail = async () => {
    setLoading(true);
    try { const res = await returnApi.detail(id); setDetail(res.data); }
    catch (err) { message.error('加载详情失败'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadDetail(); }, [id]);

  const handleStatusChange = async (values) => {
    try { await returnApi.updateStatus(id, values); message.success('状态更新成功'); setStatusModal(false); loadDetail(); } catch (err) {
      const msg = err?.response?.data?.message || err?.message || '状态更新失败，请重试';
      message.error(msg);
    }
  };

  const handleComplete = async (values) => {
    try { await returnApi.complete(id, values); message.success('工单已办结'); setCompleteModal(false); loadDetail(); } catch (err) { }
  };

  if (loading || !detail) return <div style={{ textAlign: 'center', padding: 100 }}><Spin size="large" /></div>;

  return (
    <div>
      <Card title={`返修工单 ${detail.return_no}`} extra={
        <Space>
          {detail.status !== 'completed' && detail.status !== 'cancelled' && (
            <Button onClick={() => { form.resetFields(); setStatusModal(true); }} icon={<EditOutlined />}>变更状态</Button>
          )}
          {detail.status !== 'completed' && detail.status !== 'cancelled' && (
            <Button type="primary" onClick={() => { form.resetFields(); setCompleteModal(true); }} icon={<CheckOutlined />}>办结</Button>
          )}
        </Space>
      }>
        <Descriptions bordered column={2} size="small">
          <Descriptions.Item label="单号">{detail.return_no}</Descriptions.Item>
          <Descriptions.Item label="状态"><Tag color={statusColors[detail.status]}>{statusMap[detail.status]}</Tag></Descriptions.Item>
          <Descriptions.Item label="客户姓名">{detail.customer_name}</Descriptions.Item>
          <Descriptions.Item label="电话">{detail.phone}</Descriptions.Item>
          <Descriptions.Item label="回寄地址" span={2}>{detail.return_address}</Descriptions.Item>
          <Descriptions.Item label="联系人">{detail.contact_person}</Descriptions.Item>
          <Descriptions.Item label="SN号">{detail.sn_number || '无'}</Descriptions.Item>
          <Descriptions.Item label="故障描述" span={2}>{detail.fault_desc}</Descriptions.Item>
          <Divider>供应商信息</Divider>
          <Descriptions.Item label="供应商">{detail.supplier}</Descriptions.Item>
          <Descriptions.Item label="供应商电话">{detail.supplier_phone}</Descriptions.Item>
          <Descriptions.Item label="寄往地址" span={2}>{detail.supplier_address}</Descriptions.Item>
          <Descriptions.Item label="供应商联系人">{detail.supplier_contact}</Descriptions.Item>
          <Descriptions.Item label="提醒次数"><Tag color={detail.remind_count > 0 ? 'red' : 'default'}>{detail.remind_count}</Tag></Descriptions.Item>
          {detail.customer_express_no && (
            <Descriptions.Item label="客户快递">{detail.customer_express_company} {detail.customer_express_no}</Descriptions.Item>
          )}
          <Descriptions.Item label="最近提醒">{detail.last_remind_at ? new Date(detail.last_remind_at).toLocaleString('zh-CN') : '无'}</Descriptions.Item>
          <Descriptions.Item label="创建时间">{new Date(detail.created_at).toLocaleString('zh-CN')}</Descriptions.Item>
          <Descriptions.Item label="办结时间">{detail.completed_at ? new Date(detail.completed_at).toLocaleString('zh-CN') : '-'}</Descriptions.Item>
        </Descriptions>
      </Card>

      {detail.sn_image && (
        <Card title="SN照片" size="small" style={{ marginTop: 16 }}>
          <img src={detail.sn_image} alt="SN照片" style={{ maxWidth: 400 }} />
        </Card>
      )}

      {/* 状态变更弹窗 */}
      <Modal title="变更状态" open={statusModal} onCancel={() => setStatusModal(false)} onOk={() => form.submit()}>
        <Form form={form} layout="vertical" onFinish={handleStatusChange}>
          <Form.Item name="status" label="目标状态" rules={[{ required: true, message: '请选择目标状态' }]}>
            <Select
              placeholder="请选择目标状态"
              options={[
                { value: 'sent', label: '已寄出' },
                { value: 'processing', label: '处理中' },
                { value: 'cancelled', label: '已取消' },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* 办结弹窗 */}
      <Modal title="办结返修工单" open={completeModal} onCancel={() => setCompleteModal(false)} onOk={() => form.submit()}>
        <Form form={form} layout="vertical" onFinish={handleComplete}>
          <Form.Item name="return_express_no" label="发回快递单号">
            <Input placeholder="如有发回快递，请填写单号" />
          </Form.Item>
          <Form.Item name="return_express_company" label="发回快递公司">
            <Input placeholder="如京东快递" />
          </Form.Item>
          <Form.Item name="remark" label="备注">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ReturnDetail;
